<div class="report-navigation" data-test="report-navigation">
  <nav mat-tab-nav-bar [mat-stretch-tabs]="false" color="accent" [tabPanel]="tabPanel">
    <a
      mat-tab-link
      [routerLink]="['/report']"
      [active]="true"
      [disabled]="(cycles$ | async)?.length === 0"
    >
      {{ 'report-navigation.barn-report' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
